var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 18.3333L18.334 21.6667L25.834 14.1667M19.9892 8.55969C16.657 4.664 11.1002 3.61607 6.92514 7.18336C2.75006 10.7506 2.16226 16.715 5.44098 20.934C7.91747 24.1207 14.9528 30.5183 18.2473 33.4581C18.853 33.9986 19.1558 34.2688 19.5104 34.3752C19.8182 34.4675 20.1603 34.4675 20.4681 34.3752C20.8227 34.2688 21.1255 33.9986 21.7311 33.4581C25.0257 30.5183 32.061 24.1207 34.5375 20.934C37.8162 16.715 37.3002 10.7131 33.0533 7.18336C28.8065 3.6536 23.3215 4.664 19.9892 8.55969Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckHeart);
export default __webpack_public_path__ + "static/media/iconCheckHeart.9193592a39c2171c79da42d479a37d11.svg";
export { ForwardRef as ReactComponent };